import { configureHooks } from '../providers';
import { useDebugData, useDiagram, useFilter, useGearboxData, useLoadData, useStartingConstraint, useTestPage } from './application';

export const hooks = configureHooks({
    filter: { hook: useFilter },
    loadData: { hook: useLoadData },
    startingConstraint: { hook: useStartingConstraint },
    gearboxData: { hook: useGearboxData },
    diagram: { hook: useDiagram },
    debugData: { hook: useDebugData },
    testPage: { hook: useTestPage }
});

export const useHook = hooks.useHook;
